import { render, staticRenderFns } from "./ModalDeleteCnpj.vue?vue&type=template&id=731366c5&scoped=true&lang=true&"
import script from "./ModalDeleteCnpj.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteCnpj.vue?vue&type=script&lang=js&"
import style0 from "./ModalDeleteCnpj.vue?vue&type=style&index=0&id=731366c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731366c5",
  null
  
)

export default component.exports